module.exports = __webpack_public_path__ + "static/media/twitch-status-viewer.ddde1309.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitch-status-viewer.png
// module id = 73
// module chunks = 0